

export class RegressionParams {

  public intercept: number = 0;
  public p_value:   number = 0;
  public r_value:   number = 0;
  public slope:     number = 0;
  public std_err:   number = 0

  /** standard constructor */
  public constructor(init?: Partial<RegressionParams>) {

    Object.assign(this, init);
  }
}
